export enum GcpInstructionType {
  REMEASURE = 'REMEASURE',
  // Eventually will also include:
  // USE_AS_RTK_BASE_LOCATION = "USE_AS_RTK_BASE_LOCATION",
  // MEASURE_OUTER_CORNER = "MEASURE_OUTER_CORNER"
}
